import '@babel/polyfill';
import 'url-polyfill';
import 'core-js/es6/string';

import { polyfill as arrayForEachPolyfill } from 'foreach-polyfill';
import { customPolyfills } from './util/helper';

arrayForEachPolyfill();
customPolyfills();

import 'rheostat/css/rheostat.css';
import 'react-dates/lib/css/_datepicker.css';

import ThemedStyleSheet from 'react-hawksearch/node_modules/react-with-styles/lib/ThemedStyleSheet';
import cssInterface from 'react-hawksearch/node_modules/react-with-styles-interface-css';
import RheostatDefaultTheme from 'rheostat/lib/themes/DefaultTheme';
import ReactDatesDefaultTheme from 'react-dates/lib/theme/DefaultTheme';

ThemedStyleSheet.registerInterface(cssInterface);
ThemedStyleSheet.registerTheme({
	...RheostatDefaultTheme,
	...ReactDatesDefaultTheme,
});

import "./widgets/hawksearch-box";
import "./widgets/hawksearch-results";